// extracted by mini-css-extract-plugin
export default {"parent":"ChatMessages_parent__NPwmm","info":"ChatMessages_info__C0LSU","profileinfo":"ChatMessages_profileinfo__HyNSD"};